import { render, staticRenderFns } from "./dataBox5.vue?vue&type=template&id=74e524e3&scoped=true&"
import script from "./dataBox5.vue?vue&type=script&lang=ts&"
export * from "./dataBox5.vue?vue&type=script&lang=ts&"
import style0 from "./dataBox5.vue?vue&type=style&index=0&id=74e524e3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e524e3",
  null
  
)

export default component.exports